const BASE_URL = process.env.REACT_APP_BASE_API_URL
// const BASE_URL = 'http://localhost:7071/api'
// const BASE_URL = "https://asia-east2-dc-app-251009.cloudfunctions.net"
// const BASE_URL = "https://datacleaningproduction.azurewebsites.net/api"
const lorriApplicationServices = 'https://lorriapplicationservices.azurewebsites.net'
const lorriApplicationServices1 = 'https://lorriapplicationservicesstagingnew.azurewebsites.net'
export const Urls = {
    autocomplete: 'https://production.lorri.in/api/apiuser/autocomplete',
    upload_metadata: `${BASE_URL}/metadata`,
    getUser: `${BASE_URL}/login`,
    get_file_url: 'https://ajitdc.azurewebsites.net/api/blob_file',
    // logisticsnowFileService: `${lorriApplicationServices}/api/blob-upload`,
    logisticsnowFileService: `${lorriApplicationServices1}/api/blob-upload`,
    // fileService: `${lorriApplicationServices}/api/fileupload`,
    fileService: `${lorriApplicationServices1}/api/fileupload`,
    upload_file: `${BASE_URL}/upload_file`,
    header_mapping: `${BASE_URL}/header_mapping`,
    calculation: `${BASE_URL}/calculation`,
    location: {
        fetch: `${BASE_URL}/location_fetching`,
        dump: `${BASE_URL}/location_dumping`,
        manual: `${BASE_URL}/location_manual`
    },
    master: `${BASE_URL}/dataset_master`,
    dataset: {
        fetch: `${BASE_URL}/dataset_fetching`,
        dump: `${BASE_URL}/dataset_dumping`
    },
    database: {
        dump: `${BASE_URL}/database_dumping`
    },
    consolidation: `${BASE_URL}/final_consolidation`,
    download_file: `${BASE_URL}/download`,
    download_ppt: `${BASE_URL}/ppt_dc`,
    summary: `${BASE_URL}/summary`,
    monitoring: `${BASE_URL}/monitoring`,
    review: {
        fetching: `${BASE_URL}/review_fetching`,
        dumping: `${BASE_URL}/review_dumping`
    },
    // logActivity: 'https://userpreprodnew.azurewebsites.net/api/log'
};